import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Shield, Menu, X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/utils/cn'

export function LandingNavigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Brand */}
          <Link
            to="/"
            className="flex items-center gap-x-2 text-gray-900 dark:text-white"
          >
            <Shield className="h-7 w-7 text-blue-600" />
            <span className="text-xl font-semibold">RiskLens</span>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden sm:flex items-center gap-x-6">
            <Link
              to="/examples"
              className="text-sm font-medium text-gray-600 hover:text-gray-900
                dark:text-gray-300 dark:hover:text-white transition-colors"
            >
              Examples
            </Link>
            <Button variant="ghost" size="sm" asChild>
              <Link to="/login">Sign In</Link>
            </Button>
            <Button size="sm" asChild>
              <Link to="/register">Sign Up</Link>
            </Button>
          </nav>

          {/* Mobile hamburger */}
          <div className="sm:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <X className="h-5 w-5" />
              ) : (
                <Menu className="h-5 w-5" />
              )}
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div
          className={cn(
            'sm:hidden border-t border-gray-200 dark:border-gray-800',
            'bg-white dark:bg-gray-900'
          )}
        >
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/examples"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-sm font-medium text-gray-600 hover:text-gray-900
                dark:text-gray-300 dark:hover:text-white transition-colors py-2"
            >
              Examples
            </Link>
            <div className="flex flex-col gap-y-2 pt-2 border-t border-gray-100 dark:border-gray-800">
              <Button variant="ghost" asChild className="justify-start">
                <Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>
                  Sign In
                </Link>
              </Button>
              <Button asChild className="justify-start">
                <Link to="/register" onClick={() => setIsMobileMenuOpen(false)}>
                  Sign Up
                </Link>
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}
